module.exports = __webpack_public_path__ + "img/invitation-card3.0726faf0.jpg";